.mobileFilterRow {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  margin-top: 16px;
  margin-left: 16px;
  margin-right: 16px;
  overflow-x: scroll;
}

.mobileActionSlot {
  display: contents;
}

@media all and (--reefer-media-tablet-min) {
  .mobileFilterRow {
    display: none;
  }

  .mobileActionSlot {
    display: none;
  }
}
